import { render } from "./Breadcrumbs2.vue?vue&type=template&id=4d1f978a"
import script from "./Breadcrumbs2.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs2.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Breadcrumbs2.vue?vue&type=style&index=0&id=4d1f978a&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script